import React from 'react';
import { Volume2, Square, Copy, Check } from 'lucide-react';

const MessageActions = ({
  message,
  isVisible,
  isSpeaking,
  speakingMessageId,
  copyStatus,
  onSpeak,
  onCopy
}) => {
  if (!message.text || typeof message.text !== 'string') return null;

  return (
    <div
      className={`flex space-x-1 mt-2 transition-opacity duration-200 ${
        isVisible ? 'opacity-100' : 'opacity-0'
      }`}
    >
      <button
        onClick={() => onSpeak(message.text, message.id)}
        className="pt-1.5 pb-1.5 pr-2 rounded-full text-gray-600 dark:text-gray-400"
        title={
          isSpeaking && speakingMessageId === message.id
            ? 'Stop'
            : 'Read aloud'
        }
      >
        {isSpeaking && speakingMessageId === message.id ? (
          <Square size={16} />
        ) : (
          <Volume2 size={16} />
        )}
      </button>
      <button
        onClick={() => onCopy(message.text)}
        className="p-1.5 rounded-full text-gray-600 dark:text-gray-400"
        title="Copy"
      >
        {copyStatus[message.text] ? <Check size={16} /> : <Copy size={16} />}
      </button>
    </div>
  );
};

export default MessageActions;